import React from "react";
import moment from "moment";
import Select from 'react-select';
import Notify from '../Notify.js';
import TablaReporteMovimientos from './TablaReporteMovimientos';

class ReporteMPComprobantes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            IdCaja: 0,
            dataCaj: {
                cajasSucursal: []
            },
            IdUsuario: 0,
            dataUser: {
                usuariosSucursal: []
            },
            IdSucursal: "",
            listaSucursales: [],
            fechaBusquedaInicio: moment().format('YYYY-MM-DD'),
            fechaBusquedaFin: moment().format('YYYY-MM-DD'),
            isLoading: false,
            loadingCajas: false,
            loadingUsuarios: false,
            loadingSucursales: false,
            loadingTurnos: false,
            loadingReporte: false,
            error: null,
            selectedCajaOption: null,
            selectedUserOption: null,
            selectedSucursalOption: null,
            dataTur: { turnos: [] },
            IdTurno: '',
            selectedTurnoOption: [],
            mostrarTurno: false,
            mostrarReporte: false,
            reporteData: null,
            showHelp: false
        }

        this.obtenerSucursales = this.obtenerSucursales.bind(this);
        this.obtenerCajas = this.obtenerCajas.bind(this);
        this.obtenerUsuarios = this.obtenerUsuarios.bind(this);
        this.handleChangeUsuario = this.handleChangeUsuario.bind(this);
        this.limpiarData = this.limpiarData.bind(this);
        this.handleChangeFechaBusqueda = this.handleChangeFechaBusqueda.bind(this);
        this.handleChangeCajaSelect = this.handleChangeCajaSelect.bind(this);
        this.handleSelectSucursal = this.handleSelectSucursal.bind(this);
        this.ToDay = this.ToDay.bind(this);
        this.obtenerTurnos = this.obtenerTurnos.bind(this);
        this.onCambioTurnoChange = this.onCambioTurnoChange.bind(this);
        this.generarReporteMovimientos = this.generarReporteMovimientos.bind(this);
    }

    componentDidMount() {
        this.obtenerSucursales();
    }

    obtenerSucursales = async () => {
        this.setState({ loadingSucursales: true, error: null });
        try {
            const response = await fetch(`/api/configFactElectronica/SucursalEmpresa`);
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            const data = await response.json();
            this.setState({
                loadingSucursales: false,
                listaSucursales: data,
                error: null
            });
        } catch (error) {
            this.setState({
                loadingSucursales: false,
                error: error.message,
                listaSucursales: []
            });
        }
    }

    obtenerCajas = async (IdSucursal) => {
        this.setState({ loadingCajas: true, error: null });
        try {
            let url = '/api/turnos/cajas/comprobante';
            
            if (IdSucursal) {
                url = `/api/turnos/cajas/comprobante/${IdSucursal}`;
            }
            
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            const data = await response.json();
            
            this.setState({
                loadingCajas: false,
                dataCaj: data || { cajasSucursal: [] },
                extImg: data.extImg,
                error: null
            });
        } catch (error) {
            this.setState({
                loadingCajas: false,
                error: error.message,
                dataCaj: { cajasSucursal: [] }
            });
        }
    }

    obtenerUsuarios = async (IdSucursal) => {
        this.setState({ loadingUsuarios: true, error: null });
        try {
            let url = '/api/turnos/usuarios/comprobante';
            
            if (IdSucursal) {
                url = `/api/turnos/usuarios/comprobante/${IdSucursal}`;
            }
            
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            const data = await response.json();
            this.setState({
                loadingUsuarios: false,
                dataUser: data || { usuariosSucursal: [] },
                error: null
            });
        } catch (error) {
            this.setState({
                loadingUsuarios: false,
                error: error.message,
                dataUser: { usuariosSucursal: [] }
            });
        }
    }

    handleChangeCajaSelect = (selectedOption) => {
        if (selectedOption) {
            this.setState({
                IdCaja: selectedOption.IdCaja || selectedOption.value,
                selectedCajaOption: selectedOption,
                mostrarTurno: false,
                mostrarReporte: false,
                dataTur: { turnos: [] },
                IdTurno: '',
                selectedTurnoOption: [],
                reporteData: null
            }, () => {
                if (this.state.IdCaja === 0) {
                    this.setState({ IdTurno: '' });
                }
                this.limpiarData();
            });
        } else {
            this.setState({
                IdCaja: 0,
                selectedCajaOption: null,
                IdTurno: '',
                mostrarTurno: false,
                mostrarReporte: false,
                dataTur: { turnos: [] },
                selectedTurnoOption: [],
                reporteData: null
            });
            this.limpiarData();
        }
    }

    handleChangeUsuario = (selectedOption) => {
        if (selectedOption) {
            this.setState({
                IdUsuario: selectedOption.IdUsuario || selectedOption.value,
                selectedUserOption: selectedOption,
                mostrarTurno: false,
                mostrarReporte: false,
                dataTur: { turnos: [] },
                IdTurno: '',
                selectedTurnoOption: [],
                reporteData: null
            });
        } else {
            this.setState({
                IdUsuario: 0,
                selectedUserOption: null,
                mostrarTurno: false,
                mostrarReporte: false,
                dataTur: { turnos: [] },
                IdTurno: '',
                selectedTurnoOption: [],
                reporteData: null
            });
        }
        this.limpiarData();
    }

    handleSelectSucursal = (selectedOption) => {
        if (selectedOption) {
            this.setState({
                IdSucursal: selectedOption.value,
                selectedSucursalOption: selectedOption,
                selectedCajaOption: null,
                selectedUserOption: null,
                IdCaja: 0,
                IdUsuario: 0,
                mostrarTurno: false,
                mostrarReporte: false,
                dataTur: { turnos: [] },
                IdTurno: '',
                selectedTurnoOption: [],
                reporteData: null
            }, () => {
                this.obtenerCajas(selectedOption.value);
                this.obtenerUsuarios(selectedOption.value);
                this.limpiarData();
            });
        } else {
            this.setState({
                IdSucursal: "",
                selectedSucursalOption: null,
                selectedCajaOption: null,
                selectedUserOption: null,
                IdCaja: 0,
                IdUsuario: 0,
                dataCaj: { cajasSucursal: [] },
                dataUser: { usuariosSucursal: [] },
                mostrarTurno: false,
                mostrarReporte: false,
                dataTur: { turnos: [] },
                IdTurno: '',
                selectedTurnoOption: [],
                reporteData: null
            });
            this.limpiarData();
        }
    }

    handleChangeFechaBusqueda = (e) => {
        const { name, value } = e.target;
        
        let updates = { 
            [name]: value, 
            PDF: true, 
            IdTurno: '',
            mostrarTurno: false,
            mostrarReporte: false,
            dataTur: { turnos: [] },
            selectedTurnoOption: [],
            reporteData: null
        };
        
        if (name === 'fechaBusquedaInicio' && moment(value).isAfter(moment(this.state.fechaBusquedaFin))) {
            updates.fechaBusquedaFin = value;
        }
        
        this.setState(updates, () => {
            this.limpiarData();
        });
    }

    ToDay = () => {
        return moment().format('YYYY-MM-DD');
    }

    limpiarData = () => {
        this.setState({ 
            IdTurno: '',
            datosReporte: {},
            mostrarReporte: false,
            reporteData: null
        });
    }

    obtenerTurnos = async (mostrarNotify = true) => {
        const { IdCaja, IdUsuario, fechaBusquedaInicio, fechaBusquedaFin } = this.state;

        if (!fechaBusquedaInicio && mostrarNotify) {
            return Notify("Debes ingresar una fecha de inicio", "warning", 1500);
        }
        if (!fechaBusquedaFin && mostrarNotify) {
            return Notify("Debes ingresar una fecha de fin", "warning", 1500);
        }
        if (!IdCaja && mostrarNotify) {
            return Notify("Debes seleccionar una caja", "warning", 1500);
        }
        if (!IdUsuario && mostrarNotify) {
            return Notify("Debes seleccionar un usuario", "warning", 1500);
        }

        this.setState({ 
            loadingTurnos: true, 
            error: null,
            mostrarTurno: false,
            dataTur: { turnos: [] },
            IdTurno: '',
            selectedTurnoOption: [],
            mostrarReporte: false,
            reporteData: null
        });

        try {
            const response = await fetch(
                `/api/turnos/turnosCaj/${IdCaja}/${fechaBusquedaInicio}/${fechaBusquedaFin}/${IdUsuario}`
            );
            
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.turnos && data.turnos.length > 0) {
                this.setState({
                    loadingTurnos: false,
                    dataTur: data,
                    mostrarTurno: true
                });
                
                if (mostrarNotify) {
                    Notify(`Se encontraron ${data.turnos.length} turnos`, "success", 2000);
                }
            } else {
                this.setState({
                    loadingTurnos: false,
                    dataTur: { turnos: [] },
                    mostrarTurno: false
                });
                
                if (mostrarNotify) {
                    Notify("No se han encontrado turnos, por favor revise los parámetros de búsqueda", "warning", 3500);
                }
            }
        } catch (error) {
            this.setState({ 
                loadingTurnos: false, 
                error: error.message,
                dataTur: { turnos: [] },
                mostrarTurno: false
            });
            
            if (mostrarNotify) {
                Notify("Error al cargar los turnos", "error", 2500);
            }
        }
    }

    onCambioTurnoChange = (selectedOptions) => {
        const turnosSeleccionados = Array.isArray(selectedOptions) ? selectedOptions : [];
        const idsTurno = turnosSeleccionados
            .map((turno) => turno.value)
            .filter((id) => id !== null && id !== undefined)
            .join(',');

        this.setState({
            IdTurno: idsTurno,
            selectedTurnoOption: turnosSeleccionados,
            mostrarReporte: false,
            reporteData: null
        });
    }

    generarReporteMovimientos = async () => {
        const { IdTurno } = this.state;
        
        if (!IdTurno) {
            return Notify("Debes seleccionar al menos un turno", "warning", 1500);
        }

        this.setState({ 
            loadingReporte: true, 
            error: null,
            mostrarReporte: false,
            reporteData: null
        });

        try {
            const response = await fetch(`/api/turnos/movimientosTurno/comprobante?turnos=${encodeURIComponent(IdTurno)}`);
            
            if (!response.ok) {
                throw new Error(`Error HTTP: ${response.status}`);
            }
            
            const data = await response.json();
            
            if (data.success && data.data) {
                this.setState({
                    loadingReporte: false,
                    reporteData: data.data,
                    mostrarReporte: true
                });
                
                Notify("Reporte generado exitosamente", "success", 2000);
            } else {
                throw new Error(data.message || "Error en la respuesta del servidor");
            }
            
        } catch (error) {
            this.setState({ 
                loadingReporte: false, 
                error: error.message,
                mostrarReporte: false,
                reporteData: null
            });
            
            Notify("Error al generar el reporte", "error", 2500);
        }
    }

    handleRetry = (resource) => {
        const { IdSucursal } = this.state;
        
        switch(resource) {
            case 'cajas':
                this.obtenerCajas(IdSucursal);
                break;
            case 'usuarios':
                this.obtenerUsuarios(IdSucursal);
                break;
            case 'sucursales':
                this.obtenerSucursales();
                break;
            default:
                this.obtenerCajas(IdSucursal);
                this.obtenerUsuarios(IdSucursal);
                this.obtenerSucursales();
        }
    }

    render() {
        const { 
            loadingCajas, 
            loadingUsuarios, 
            loadingSucursales,
            loadingTurnos,
            loadingReporte,
            isLoading,
            error, 
            dataCaj, 
            dataUser,
            dataTur,
            selectedCajaOption, 
            selectedUserOption,
            selectedSucursalOption,
            selectedTurnoOption,
            fechaBusquedaInicio,
            fechaBusquedaFin,
            listaSucursales,
            IdSucursal,
            IdTurno,
            mostrarTurno,
            mostrarReporte,
            reporteData,
            showHelp
        } = this.state;

        const cajaOptions = dataCaj?.cajasSucursal?.map(caja => ({
            value: caja.IdCaja,
            label: caja.Nombre,
            IdCaja: caja.IdCaja,
            Nombre: caja.Nombre
        })) || [];

        const usuarioOptions = dataUser?.usuariosSucursal?.map(usuario => ({
            value: usuario.IdUsuario,
            label: usuario.Usuario,
            IdUsuario: usuario.IdUsuario,
            Usuario: usuario.Usuario
        })) || [];

        const sucursalOptions = listaSucursales?.map(sucursal => ({
            value: sucursal.IdSucursal?.toString() || "",
            label: sucursal.Nombre || `Sucursal ${sucursal.IdSucursal}`,
            IdSucursal: sucursal.IdSucursal,
            Nombre: sucursal.Nombre
        })) || [];

        const turnoOptions = dataTur?.turnos?.map(turno => ({
            value: turno.IdTurnoCaja,
            label: turno.FechaFin 
                ? `Turno: ${turno.IdTurnoCaja} - Apertura: ${moment(turno.FechaInicio).format('DD/MM/YYYY HH:mm')} - Cierre: ${moment(turno.FechaFin).format('DD/MM/YYYY HH:mm')}`
                : `Turno: ${turno.IdTurnoCaja} - Apertura: ${moment(turno.FechaInicio).format('DD/MM/YYYY HH:mm')} - Cierre: Turno en curso`,
            IdTurnoCaja: turno.IdTurnoCaja,
            FechaInicio: turno.FechaInicio,
            FechaFin: turno.FechaFin,
            Observacion: turno.Observacion,
            Ruc: turno.Ruc,
            MontoInicial: turno.MontoInicial
        })) || [];
        
        const styleCalendar = {
            border: "0.5px solid #acacac", 
            borderRadius: "25px", 
            outline: "none", 
            flexBasis: "50%", 
            alignSelf: "center"
        };
        
        return (
            <div className="">
                <div className="justify-content-center contenedor-fecha-fpay caja-fondo-blanco-m-2 mt-3">
                    <span className="align-self-center letra-fecha-fpay">
                        Desde: 
                    </span>
                    <input
                        type="date"
                        name="fechaBusquedaInicio"
                        onChange={this.handleChangeFechaBusqueda}
                        value={fechaBusquedaInicio}
                        className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                        style={styleCalendar}
                        max={this.ToDay()}
                    />
                    <span className="align-self-center letra-fecha-fpay">
                        Hasta: 
                    </span>
                    <input 
                        type="date"
                        name="fechaBusquedaFin"
                        onChange={this.handleChangeFechaBusqueda}
                        value={fechaBusquedaFin}
                        className="input__linea mr-1 mt-3 mb-3 linea-fecha-fpay"
                        style={styleCalendar}
                        min={fechaBusquedaInicio}
                        max={this.ToDay()}
                    />
                </div>
                
                <div className="container">
                <div className="mb-2 mt-2">
                    <button
                        className="btn btn-outline-danger btn-sm"
                        onClick={() => this.setState({ showHelp: true })}
                        title="Ver guía de uso"
                    >
                        <i className="fas fa-question-circle mr-1"/> HELP
                    </button>
                </div>

                {(loadingCajas || loadingUsuarios || loadingSucursales || loadingTurnos || isLoading || loadingReporte) && (
                    <div className="alert alert-info">
                        Cargando datos...
                        {loadingCajas && " Cajas..."}
                        {loadingUsuarios && " Usuarios..."}
                        {loadingSucursales && " Sucursales..."}
                        {loadingTurnos && " Turnos..."}
                        {loadingReporte && " Reporte..."}
                        {isLoading && " Generando reporte..."}
                    </div>
                )}
                
                {error && (
                    <div className="alert alert-danger">
                        Error: {error}
                        <button 
                            onClick={() => this.handleRetry('all')} 
                            className="btn btn-sm btn-secondary ml-2"
                        >
                            Reintentar
                        </button>
                    </div>
                )}
                <div className="caja-fondo-blanco-m-2 p-3 mb-3">
                    <h4 className="sucursal-text-color mb-3">Selecciona la Sucursal</h4>
                    <div className="form-group">
                        {loadingSucursales ? (
                            <div className="alert alert-info">Cargando sucursales...</div>
                        ) : (
                            <>
                                <Select
                                    value={selectedSucursalOption}
                                    onChange={this.handleSelectSucursal}
                                    options={sucursalOptions}
                                    placeholder="Seleccionar Sucursal"
                                    isClearable
                                    isLoading={loadingSucursales}
                                    noOptionsMessage={() => "No hay sucursales disponibles"}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            minHeight: "38px"
                                        })
                                    }}
                                />
                                <small className="text-muted">
                                    {sucursalOptions.length} sucursales disponibles
                                </small>
                            </>
                        )}
                    </div>
                </div>

                <div className="caja-fondo-blanco-m-2 p-3">
                    <div className="row">
                        <div className="col-12 col-md-6 mb-3">
                            <div className="form-group">
                                <label className="form-label">
                                    <b style={{ color: "red" }}>* </b> Cajas:
                                </label>
                                <Select
                                    value={selectedCajaOption}
                                    onChange={this.handleChangeCajaSelect}
                                    options={cajaOptions}
                                    placeholder={IdSucursal ? "Seleccionar Caja" : "Primero selecciona una sucursal"}
                                    isClearable
                                    isLoading={loadingCajas}
                                    isDisabled={!IdSucursal}
                                    noOptionsMessage={() => IdSucursal ? "No hay cajas disponibles para esta sucursal" : "Primero selecciona una sucursal"}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            minHeight: "38px",
                                            backgroundColor: !IdSucursal ? "#f5f5f5" : "white"
                                        })
                                    }}
                                />
                                <small className="text-muted">
                                    {IdSucursal ? `${cajaOptions.length} cajas disponibles` : "Selecciona una sucursal para ver las cajas"}
                                </small>
                            </div>
                        </div>

                        <div className="col-12 col-md-6 mb-3">
                            <div className="form-group">
                                <label className="form-label">
                                    <b style={{ color: "red" }}>* </b> Usuario:
                                </label>
                                <Select
                                    value={selectedUserOption}
                                    onChange={this.handleChangeUsuario}
                                    options={usuarioOptions}
                                    placeholder={IdSucursal ? "Seleccionar Usuario" : "Primero selecciona una sucursal"}
                                    isClearable
                                    isLoading={loadingUsuarios}
                                    isDisabled={!IdSucursal}
                                    noOptionsMessage={() => IdSucursal ? "No hay usuarios disponibles para esta sucursal" : "Primero selecciona una sucursal"}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            minHeight: "38px",
                                            backgroundColor: !IdSucursal ? "#f5f5f5" : "white"
                                        })
                                    }}
                                />
                                <small className="text-muted">
                                    {IdSucursal ? `${usuarioOptions.length} usuarios disponibles` : "Selecciona una sucursal para ver los usuarios"}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="m-3 d-flex justify-content-end"> 
                    <button 
                        className="btn btn-verde-mfp btn-block"
                        onClick={() => this.obtenerTurnos(true)}
                        disabled={loadingTurnos || !this.state.IdCaja || !this.state.IdUsuario}
                    >
                        {loadingTurnos ? (
                            <>
                                <span className="spinner-border spinner-border-sm mr-2"></span>
                                Cargando Turnos...
                            </>
                        ) : 'Cargar Turnos'}
                    </button>
                </div>

                {mostrarTurno && turnoOptions.length > 0 && (
                    <div className="caja-fondo-blanco-m-2 p-3 mb-3">
                        <div className="row">
                            <div className="col-sm-auto d-flex align-items-center">
                                <b style={{ color: "red" }}>* </b> Turnos:
                            </div>
                            <div className="col-sm">
                                <Select
                                    name="IdTurno"
                                    value={selectedTurnoOption}
                                    onChange={this.onCambioTurnoChange}
                                    options={turnoOptions}
                                    placeholder="Seleccionar Turnos"
                                    isClearable
                                    isMulti
                                    closeMenuOnSelect={false}
                                    isLoading={loadingTurnos}
                                    noOptionsMessage={() => "No hay turnos disponibles"}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                            minHeight: "38px"
                                        })
                                    }}
                                />
                                <small className="text-muted">
                                    {turnoOptions.length} turnos disponibles
                                </small>
                            </div>
                        </div>
                        
                        {IdTurno && (
                            <div className="row mt-3">
                                <div className="col-12">
                                    <button 
                                        className="btn btn-verde-mfp btn-block"
                                        onClick={this.generarReporteMovimientos}
                                        disabled={loadingReporte}
                                    >
                                        {loadingReporte ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm mr-2"></span>
                                                Generando Reporte...
                                            </>
                                        ) : 'Generar Reporte de Movimientos'}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {mostrarReporte && reporteData && (
                    <TablaReporteMovimientos reporteData={reporteData} />
                )}
                </div>

                {showHelp && (
                    <div
                        className="modal fade show"
                        style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                            <div className="modal-content">
                                <div className="modal-header text-white" style={{ background: '#35605a' }}>
                                    <h5 className="modal-title">
                                        <i className="fas fa-book-open mr-2"/>
                                        Guía: Reporte de Movimientos por Comprobantes
                                    </h5>
                                    <button
                                        type="button"
                                        className="close text-white"
                                        onClick={() => this.setState({ showHelp: false })}
                                        aria-label="Cerrar"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">

                                    <div className="alert alert-info">
                                        <i className="fas fa-info-circle mr-2"/>
                                        Esta guía explica el flujo completo del reporte, desde los filtros hasta la visualización y exportación de datos.
                                    </div>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-calendar-alt mr-2"/>1. Filtros de fecha</h6>
                                    <p>En la parte superior encontrarás dos campos <strong>Desde</strong> y <strong>Hasta</strong>. La fecha <em>Hasta</em> no puede ser menor que la fecha <em>Desde</em> y ninguna puede superar la fecha actual. Si ajustas la fecha inicio más allá del fin, la fecha fin se actualiza automáticamente.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-building mr-2"/>2. Selección de Sucursal</h6>
                                    <p>El selector de <strong>Sucursal</strong> se carga automáticamente al abrir la página. Al elegir una sucursal el sistema carga inmediatamente las <strong>cajas</strong> y los <strong>usuarios</strong> disponibles para esa sucursal.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-cash-register mr-2"/>3. Caja y Usuario</h6>
                                    <p>Los selectores de <strong>Caja</strong> y <strong>Usuario</strong> se habilitan solo después de elegir una sucursal, garantizando que las opciones mostradas correspondan a ella. Cada selector indica cuántas opciones hay disponibles y permite buscar dentro de ellas.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-search mr-2"/>4. Cargar Turnos</h6>
                                    <p>Una vez seleccionados sucursal, caja y usuario, haz clic en <strong>Cargar Turnos</strong>. El sistema consultará todos los turnos que coincidan con los filtros. Un <em>spinner</em> en el botón indica que el sistema está trabajando.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-list-ol mr-2"/>5. Selector de Turnos</h6>
                                    <p>Si existen turnos aparecerá un <strong>selector múltiple</strong> donde puedes elegir uno o varios turnos. Cada opción muestra el número de turno, fecha y hora de apertura y, si está cerrado, la fecha de cierre. Si el turno sigue abierto aparece la leyenda <em>Turno en curso</em>.</p>

                                    <h6 className="font-weight-bold text-success"><i className="fas fa-play-circle mr-2"/>6. Generar Reporte</h6>
                                    <p>Con los turnos seleccionados, haz clic en <strong>Generar Reporte de Movimientos</strong>. El sistema consultará todos los comprobantes asociados a esos turnos. Una vez listos los datos, se despliega el panel de resultados (<em>ver guía del panel de resultados en el botón HELP de la tabla</em>).</p>

                                    <div className="alert alert-secondary mb-0">
                                        <i className="fas fa-lightbulb mr-2 text-warning"/>
                                        <strong>Flujo recomendado:</strong> Elige fechas → Selecciona sucursal → Elige caja y usuario → Carga los turnos → Selecciona los turnos → Genera el reporte.
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => this.setState({ showHelp: false })}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default ReporteMPComprobantes;